import { match } from 'ts-pattern';

import { AxaLogo } from '@sh4res/bo-common/components/AxaLogo';
import { MlkLogo } from '@sh4res/bo-common/components/MlkLogo';
import { SharesLogo } from '@sh4res/bo-common/components/SharesLogo';
import { getTheme } from '@sh4res/bo-common/theme';

type LogoProps = {
  height?: string | number;
  width?: number;
};

export function BrandAwareLogo({ height, width }: LogoProps) {
  return match(getTheme())
    .with('axa', () => <AxaLogo size={height ?? 42} />)
    .with('mlk', () => <MlkLogo size={height ?? 42} width={width} />)
    .with('default', () => <SharesLogo height={height?.toString()} />)
    .exhaustive();
}
